import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb5465e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "risk-level"
}
const _hoisted_2 = ["src"]


export default /*#__PURE__*/_defineComponent({
  props: {
  level: {
    type: Number,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.level)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("img", {
          style: {"width":"1.2em","height":"1.2em","margin-right":"0.4em","position":"relative","top":"0.2em"},
          src: require(`@/assets/images/home/grade-${__props.level}.png`)
        }, null, 8, _hoisted_2),
        _createElementVNode("span", null, _toDisplayString(__props.level), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})